export const HERO_CONSTANTS = {
  button: {
    label: "Find the best IT management model for your business",
    link: "#contact-us",
  },
  content: "Protect Your Multi-Cloud & Hybrid Environments",
  title:
    "Choose the right IT management approach—fully managed, self-managed, or co-managed to optimize your cloud environment and operations.",
};
